// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  apiBaseUrl: 'http://192.168.86.20:8080',
  production: false,

  googleClientId: '144525154094-2a15dqtj1cljqb1gn08qd70pvoe4m325.apps.googleusercontent.com',

  recaptchaSiteKey: '6LeYcEktAAAAAF1v2wFCGOZbkQCP3cvL3pgdhjG0',
  
  firebase: {
      apiKey: "AIzaSyAQgVN4HhrO8jKfh2CFRb_fFKEK7FugBig",
  authDomain: "prjmay2026.firebaseapp.com",
  projectId: "prjmay2026",
  storageBucket: "prjmay2026.firebasestorage.app",
  messagingSenderId: "144525154094",
  appId: "1:144525154094:web:0363e0427f88ec0b8b0cbf",
  vapidKey: 'BGQBaVR7GUkbHgGTYDBjLqai0U9ltOlaItK1mYI2edwKTjoWmLRO2tg7Z94z5oorTUUZ33KYp9EUtZ6ZjgipeeA',
  }

};
